<template>
    <!--srccomponentsrectCardindexvuehtmlStart-->
  <div>
        <el-dialog :visible.sync="visible" center :close-on-click-modal="true" @close="handleClose"
      custom-class="dialog_normalsuo  dialog_CaptchaPage" :append-to-body="true">
      <div>
         <div class="detail_cont">
      <div class="flex_center margin-bottom20"><img style="width: 5rem;height: 4.57143rem;" src="../../assets/dialogIcoImg/CaptchaPage.png" alt=""></div>
                    <h3>Captcha Page</h3>
            <h4  class="CaptchaPage margin-top10">Login account:{{ useerName }}</h4>
            <h4 v-if="RecaptchaFalse" style="color: #FF6A6A;font-size: 14px;" class="CaptchaPage margin-top10">You may be a robot and currently unable to log in. If you have any questions, please contact us: service@csibizinfo.com Or refresh the page and re authenticate</h4>

          <div class="margin-top30 margin-bottom30 flex_center">
     <Vue-recaptcha sitekey="6Lf0n9QrAAAAAAcIE3mUj6MpTV8fw77O08pmMieu" :loadRecaptchaScript="true"
            @verify="onVerify" @expired="onExpired" @error="onError">
        </Vue-recaptcha> 
          </div>

        </div>
      </div>
      <div class="flex_center">
        <el-button class="btn_export" @click="handleClose()">Confirm</el-button>
      </div>
    </el-dialog>
    </div>

    <!--srccomponentsrectCardindexvuehtmlEnd-->
</template>
<script>
import { VueRecaptcha } from 'vue-recaptcha';
import {  recaptchaverify,  } from '@/api/api.js';

export default {
    name: "",

    props: {
    
     useerName: {
                type: String,
                default: ""
            }
    },

    mounted() {
      
    },

    components: {
        VueRecaptcha
    },
    computed: {
    newDialog: {
            get() {
                return this.suoClose;
            },
            set() { },
        },
    },
        created() {
        this.$bus.$on('show-CaptchaPage-dialog', (on)=>{
            this.showDialog()
        });
    },
    beforeDestroy() {
        this.$bus.$off('show-CaptchaPage-dialog', this.showDialog);
    },
    data() {
        return {
                visible:false,
                RecaptchaFalse:false
          
        };
    },
    methods: {
            handleClose(value){
            this.visible = false;
        },
        showDialog(value){ 

            this.visible = true;
        },
   onVerify(token) {
            recaptchaverify({
                token:token
            }).then(res=>{
                if(res.code==200&&res.data){
                    this.handleClose()
                    this.$parent.login()
                }else{
                    this.RecaptchaFalse=true
                }
           
            })
            // 将token发送到后端验证
        },
        onExpired() {
            console.log('验证过期');
            // this.RecaptchaFalse=true
        },
        onError() {
            console.log('发生错误');
            //  this.RecaptchaFalse=true
        },

        // srccomponentsrectCardindexvueMethodEnd
    },
};
</script>
<style>
.CaptchaPage{
    font-size: 1.2857143rem;
color: #1A2332;
text-align: center;
}

</style>